import React from 'react';
import ParallaxElement from '../common/ParallaxElement';

export default class WaterNinja extends React.PureComponent {
    static propTypes = {};
    render() {
        return (
            <ParallaxElement
                yStrength={0} stopX={-5} xStrength={0.1} id="water"
                xAnimateFromRight>
                <div id="waterWrapper" className="waterWrapper" />
            </ParallaxElement>
        );
    }
}

